import { useState, useEffect } from "react";
import { useAuth } from "oidc-react";

export const useDueDatesAuth = () => {
  const auth = useAuth();

  const [credentials, setCredentials] = useState({
    Token: null,
    RefreshToken: null,
    ExpiresAt: null,
    TenantId: null,
    UserEmail: null,
    UserId: null,
    UserFullName: null,
    UserRole: null,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.userData) {
      const data = auth.userData;
      setCredentials({
        Token: data?.access_token,
        RefreshToken: data?.refresh_token,
        ExpiresAt: data?.expires_at,
        TenantId: data?.profile.tenant_id,
        UserEmail: data?.profile.email,
        UserId: data?.profile.sub,
        UserFullName: data?.profile.given_name,
        UserRole: data?.profile.role,
      });
      setLoading(false);
    }
  }, [auth.userData]);

  return { ...credentials, loading };
};
